import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { OibFullInfoEmployee } from "../models/Committee";
import { SchoolCandidate } from "../models/SchoolCandidate";
import { OibIdentification, OibServiceResult } from "../models";

interface UserOibPayload {
  oib: string;
  firstName: string;
  lastName: string;
}

export const oibApi = createApi({
  reducerPath: "oibApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getEmployeeOib: build.query<
      OibServiceResult<OibFullInfoEmployee>,
      OibFullInfoEmployee
    >({
      query: (oibEmployee: OibFullInfoEmployee) => ({
        url: "oib/get-oibemployee",
        method: "post",
        data: oibEmployee,
      }),
    }),
    getUserOib: build.query<
      OibServiceResult<OibIdentification>,
      UserOibPayload
    >({
      query: (payload: UserOibPayload) => ({
        url: "users/oib",
        method: "post",
        data: payload,
      }),
    }),
    getSchoolCandidateOib: build.query<
      OibServiceResult<SchoolCandidate>,
      OibIdentification
    >({
      query: (oibIdentification: OibIdentification) => ({
        url: "school-candidates/oib",
        method: "post",
        data: oibIdentification,
      }),
    }),
  }),
});

export const {
  useGetEmployeeOibQuery,
  useLazyGetEmployeeOibQuery,
  useLazyGetSchoolCandidateOibQuery,
  useLazyGetUserOibQuery,
} = oibApi;
